<template>
  <transition-group tag="div" :name="active ? transitionName : ''">
    <slot />
  </transition-group>
</template>

<script>
export default {
  name: 'TransitionGroupSlide',

  props: {
    active: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      currentItem: null,
      isLastItem: false,
    }
  },

  computed: {
    transitionName() {
      return this.isLastItem ? 'slide-left' : 'slide-right'
    },
  },

  mounted() {
    this.currentItem = this.$slots.default[0]
  },

  updated() {
    this.currentItem = this.$slots.default.filter((item) => item.key)[0]
    if (this.$slots.default.indexOf(this.currentItem) === this.$slots.default.length - 1) {
      this.isLastItem = true
    } else {
      this.isLastItem = false
    }
    // console.log('transition-group', this.$slots.default)
  },
}
</script>

<style scoped></style>
